import { render, staticRenderFns } from "./WrongTransferComponent.vue?vue&type=template&id=fa0dc1e2"
import script from "./WrongTransferComponent.vue?vue&type=script&lang=js"
export * from "./WrongTransferComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports